const phraseTypes = {
    input: 0,
    output: 1
};

export default phraseTypes;